<template>
  <div class="public-footer-apps">
    <div class="public-footer-title">Мобильное приложение</div>
    <div class="public-footer-apps-links">
      <public-footer-app 
        v-for="app in apps" 
        :url="app.url"
        :icon-url="app.iconUrl"
        :icon-variant="app.iconVariant"
        :title="app.title"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import PublicFooterApp from '@/components/public/footer/public-footer-app.vue'
import { googleApp, appleApp, telegramBot, androidApk } from '@/api/constant-urls'

const apps = [
  {
    url: googleApp,
    iconUrl: '/svg/google-app.svg',
    title: 'Скачать <br/> в Google Store'
  },
  {
    url: appleApp,
    iconUrl: '/svg/apple-app.svg',
    title: 'Скачать <br/> в App Store',
    iconVariant: 'white'
  },
  {
    url: androidApk,
    iconUrl: '/svg/android.svg',
    title: 'Скачать <br/> APK-файл'
  },
  {
    url: telegramBot,
    iconUrl: '/svg/telegram.svg',
    title: 'Telegram Bot'
  },
]
</script>
